<div class="w-screen h-screen bg-[url('/assets/img/background/field.jpg')] bg-cover bg-center bg-no-repeat flex justify-center items-center">
<!-- <div class="w-screen h-screen bg-lugano-gray-light flex justify-center items-center"> -->

  <div class="w-1/3 min-w-80 max-w-120 bg-white shadow-xl/30 p-8 rounded-3xl">
    <h1 class="text-2xl font-bold text-center">FC Lugano</h1>

    <form class="mt-8" (submit)="login()">
      <div class="mb-4">
        <label for="email" class="block text-sm font-medium text-gray-700">Username</label>
        <input type="email" id="email" name="email" [(ngModel)]="credentials.username" required
          class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-fcb-blue focus:border-fcb-blue sm:text-sm">
      </div>
      <div class="mb-4">
        <label for="password" class="block text-sm font-medium text-gray-700">Password</label>
        <input type="password" id="password" name="password" [(ngModel)]="credentials.password" required
          class="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-full shadow-sm focus:outline-none focus:ring-fcb-blue focus:border-fcb-blue sm:text-sm">
      </div>
      <div class="h-10 mb-4 text-sm font-medium text-red-600">
        @if (isLoginError) {
        @if (errMsg && errMsg.length > 0) {
        <p>{{ errMsg }}</p>
        }
        <p>Username or password may be incorrect.</p>
        }
      </div>
      <div class="flex justify-center items-center">
        <button type="submit" class="btn-gray">Login</button>
        <!-- <a routerLink="/register" class="text-fcb-blue">Register</a> -->
      </div>
    </form>
  </div>

</div>